import React from 'react';

const Button = ({
  children, disabled, className, ...attrs
}) => {
  let classes = 'v2-form__btn v2-form__btn--primary';

  if ( className ) {
    classes += ` ${className}`;
  }

  if ( disabled ) {
    classes += ' disabled';
  }

  return (
    <button className={classes} disabled={!!disabled} {...attrs}>
      {children}
    </button>
  );
};

export default Button;
